import type { ISongPeaks, CustomizableSong, FreeSong } from '../../../entities';
import { SongService } from '../songService';
import { PaginatedList } from '../../../entities';
import { SongRepository } from '../../../network/repositories/songRepository';
import { QueryParameters } from '../../../responses/responseTypes';

export default class SongServiceImpl implements SongService {
  songRepository: SongRepository;

  constructor(songRepository: SongRepository) {
    this.songRepository = songRepository;
  }

  getSong(id: string): Promise<FreeSong | CustomizableSong> {
    const { songRepository } = this;
    return songRepository.getSong(id);
  }

  getSongList(
    queryParameters: QueryParameters
  ): Promise<PaginatedList<FreeSong | CustomizableSong>> {
    const { songRepository } = this;
    return songRepository.getSongList(queryParameters);
  }

  getSongPeaksData(jsonUrl: string): Promise<ISongPeaks> {
    const { songRepository } = this;
    return songRepository.getSongPeaksData(jsonUrl);
  }
}
